import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Formik } from "formik";
import { Upload, Image, message } from "antd";
import { MdAdd } from "react-icons/md";
import { BsQuestionCircle } from "react-icons/bs";
import Header from "../component/Home/Header";
import "./companyinit.css";
import axios from "../axios";
import { notifySuccess } from "../action/customFn";

// adding this here
const industryOptions = [
  "Information Technology",
  "Financial Services",
  "Healthcare",
  "Manufacturing",
  "Education",
  "Retail",
  "Consulting",
  "Media & Entertainment",
];

const orgSizes = ["0-10", "10-50", "50-200", "200-500", "500-1K", "1K+"];

const initialValues = {
  companyName: "",
  linkedinUrl: "",
  websiteUrl: "",
  industry: "",
  orgSize: "",
  logoFile: null,
  tagline: "",
  authorized: false,
  email: "",
  contact: "",
  password: "",
  confirmPassword: "",
};

const stepFields = {
  1: ["companyName", "linkedinUrl", "websiteUrl", "industry", "orgSize", "authorized"],
  2: ["email", "contact", "password", "confirmPassword"],
};

const validateFields = (values) => {
  const errors = {};
  const urlRegex = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/.*)?$/i;
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

  if (!values.companyName.trim()) {
    errors.companyName = "Company name is required";
  }
  if (!values.linkedinUrl.trim()) {
    errors.linkedinUrl = "LinkedIn URL is required";
  } else if (!urlRegex.test(values.linkedinUrl.trim())) {
    errors.linkedinUrl = "Provide a valid URL";
  }
  if (!values.websiteUrl.trim()) {
    errors.websiteUrl = "Website is required";
  } else if (!urlRegex.test(values.websiteUrl.trim())) {
    errors.websiteUrl = "Provide a valid URL";
  }
  if (!values.industry) {
    errors.industry = "Select an industry";
  }
  if (!values.orgSize) {
    errors.orgSize = "Select organization size";
  }
  if (!values.authorized) {
    errors.authorized = "You must verify authorization";
  }
  if (!values.email.trim()) {
    errors.email = "Email is required";
  } else if (!emailRegex.test(values.email.trim())) {
    errors.email = "Enter a valid company email";
  }
  if (!values.contact.trim()) {
    errors.contact = "Contact number is required";
  } else if (!/^[\d+\-\s()]{6,}$/i.test(values.contact.trim())) {
    errors.contact = "Enter a valid contact number";
  }
  if (!values.password) {
    errors.password = "Password is required";
  } else if (values.password.length < 8) {
    errors.password = "Password must be at least 8 characters";
  }
  if (!values.confirmPassword) {
    errors.confirmPassword = "Confirm your password";
  } else if (values.confirmPassword !== values.password) {
    errors.confirmPassword = "Passwords do not match";
  }
  return errors;
};

export const CompanyInit = () => {
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(1);
  const [logoPreview, setLogoPreview] = useState("");
  const [showLoader, setShowLoader] = useState(false);

  const handleCompanySubmit = async (values, { setSubmitting }) => {
    setSubmitting(true);
    setShowLoader(true);
    try {
      const formData = new FormData();
      const keys = Object.keys(values);
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        const value = values[key];
        formData.append(key, JSON.stringify(value));
      }
      const response = await axios.post("/auth/register-company", formData);
      if(response.status === 200) {
        notifySuccess("OK");
        // navigate("/company-dashboard");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setShowLoader(false);
      setSubmitting(false);
    }
  };

  const renderPreview = (values) => ({
    name: values.companyName || "Company Name",
    tagline: values.tagline || "Tagline",
    industry: values.industry || "Industry",
    logo: logoPreview,
  });

  return (
    <div style={{ background: "#f1f1f1", minHeight: "100vh" }}>
      <Header />
      <section className="compinitf88-section">
        <div className="center-wr">
          <Formik
            initialValues={initialValues}
            validate={validateFields}
            onSubmit={handleCompanySubmit}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setTouched,
              validateForm,
              setFieldValue,
            }) => {
              const preview = renderPreview(values);

              const handleContinue = async () => {
                const validation = await validateForm();
                const touchedMap = { ...touched };
                stepFields[1].forEach((field) => {
                  touchedMap[field] = true;
                });
                setTouched(touchedMap);
                const hasErrors = stepFields[1].some((field) => validation[field]);
                if (!hasErrors) {
                  setActiveStep(2);
                }
              };

              return (
                <main className="compinitf88-main">
                  <div className="compinitf88-form">
                    <form onSubmit={handleSubmit} className="compinitf88-form-shell">
                      <div className="compinitf88-stepper">
                        {[1, 2].map((step) => (
                          <div
                            key={step}
                            className={`compinitf88-step ${activeStep === step ? "active" : ""}`}
                          >
                            <span>{step}</span>
                            <p>{step === 1 ? "Company profile" : "Admin access"}</p>
                          </div>
                        ))}
                      </div>

                      {activeStep === 1 && (
                        <div className="compinitf88-step-content">
                          <div className="compinitf88-field">
                            <label>Company Name*</label>
                            <input
                              type="text"
                              name="companyName"
                              placeholder="MetBrains Technologies"
                              value={values.companyName}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                            {touched.companyName && errors.companyName && <small>{errors.companyName}</small>}
                          </div>

                          <div className="compinitf88-field">
                            <label>Company LinkedIn URL*</label>
                            <input
                              type="url"
                              name="linkedinUrl"
                              placeholder="https://www.linkedin.com/company/..."
                              value={values.linkedinUrl}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                            {touched.linkedinUrl && errors.linkedinUrl && <small>{errors.linkedinUrl}</small>}
                          </div>

                          <div className="compinitf88-field">
                            <label>Website URL*</label>
                            <input
                              type="url"
                              name="websiteUrl"
                              placeholder="https://"
                              value={values.websiteUrl}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                            {touched.websiteUrl && errors.websiteUrl && <small>{errors.websiteUrl}</small>}
                          </div>

                          <div className="compinitf88-inline">
                            <div className="compinitf88-field">
                              <label>Industry*</label>
                              <select
                                name="industry"
                                value={values.industry}
                                onChange={handleChange}
                                onBlur={handleBlur}
                              >
                                <option value="">Select industry</option>
                                {industryOptions.map((option) => (
                                  <option key={option} value={option}>
                                    {option}
                                  </option>
                                ))}
                              </select>
                              {touched.industry && errors.industry && <small>{errors.industry}</small>}
                            </div>

                            <div className="compinitf88-field">
                              <label>Organization size*</label>
                              <select
                                name="orgSize"
                                value={values.orgSize}
                                onChange={handleChange}
                                onBlur={handleBlur}
                              >
                                <option value="">Select size</option>
                                {orgSizes.map((size) => (
                                  <option key={size} value={size}>
                                    {size}
                                  </option>
                                ))}
                              </select>
                              {touched.orgSize && errors.orgSize && <small>{errors.orgSize}</small>}
                            </div>
                          </div>

                          <div className="compinitf88-field">
                            <label>Logo (optional)</label>
                            <Upload
                              name="logoFile"
                              showUploadList={false}
                              maxCount={1}
                              accept="image/png,image/jpeg,image/jpg"
                              beforeUpload={(file) => {
                                const typeAllowed = ["image/png", "image/jpeg", "image/jpg"].includes(file.type);
                                if (!typeAllowed) {
                                  message.error("Upload PNG or JPG only.");
                                  return Upload.LIST_IGNORE;
                                }
                                const isSmallEnough = file.size / 1024 / 1024 < 2;
                                if (!isSmallEnough) {
                                  message.error("Logo must be smaller than 2MB.");
                                  return Upload.LIST_IGNORE;
                                }
                                const reader = new FileReader();
                                reader.onload = () => {
                                  setLogoPreview(reader.result?.toString() || "");
                                  setFieldValue("logoFile", file);
                                };
                                reader.readAsDataURL(file);
                                return false;
                              }}
                            >
                              <button type="button" className="compinitf88-upload-btn">
                                Upload 300x300 PNG/JPG
                              </button>
                            </Upload>
                          </div>

                          <div className="compinitf88-field">
                            <label>Tagline (optional)</label>
                            <input
                              type="text"
                              name="tagline"
                              placeholder="We build adaptive learning journeys"
                              value={values.tagline}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                          </div>

                          <label className="compinitf88-checkbox">
                            <input
                              type="checkbox"
                              name="authorized"
                              checked={values.authorized}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                            <span>
                              I&apos;m an authorized representative and agree to the program policies.
                            </span>
                          </label>
                          {touched.authorized && errors.authorized && <small>{errors.authorized}</small>}
                        </div>
                      )}

                      {activeStep === 2 && (
                        <div className="compinitf88-step-content">
                          <div className="compinitf88-field">
                            <label>Work email*</label>
                            <input
                              type="email"
                              name="email"
                              placeholder="you@company.com"
                              value={values.email}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                            {touched.email && errors.email && <small>{errors.email}</small>}
                          </div>

                          <div className="compinitf88-field">
                            <label>Contact number*</label>
                            <input
                              type="text"
                              name="contact"
                              placeholder="+1 222 444 5555"
                              value={values.contact}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                            {touched.contact && errors.contact && <small>{errors.contact}</small>}
                          </div>

                          <div className="compinitf88-inline">
                            <div className="compinitf88-field">
                              <label>Password*</label>
                              <input
                                type="password"
                                name="password"
                                placeholder="Create a secure password"
                                value={values.password}
                                onChange={handleChange}
                                onBlur={handleBlur}
                              />
                              {touched.password && errors.password && <small>{errors.password}</small>}
                            </div>
                            <div className="compinitf88-field">
                              <label>Confirm password*</label>
                              <input
                                type="password"
                                name="confirmPassword"
                                placeholder="Re-enter password"
                                value={values.confirmPassword}
                                onChange={handleChange}
                                onBlur={handleBlur}
                              />
                              {touched.confirmPassword && errors.confirmPassword && (
                                <small>{errors.confirmPassword}</small>
                              )}
                            </div>
                          </div>
                        </div>
                      )}

                      <div className="compinitf88-actions">
                        {activeStep === 2 && (
                          <button
                            type="button"
                            className="compinitf88-btn ghost"
                            onClick={() => setActiveStep(1)}
                          >
                            Back
                          </button>
                        )}
                        {activeStep === 1 && (
                          <button type="button" className="compinitf88-btn primary" onClick={handleContinue}>
                            Continue
                          </button>
                        )}
                        {activeStep === 2 && (
                          <button type="submit" className="compinitf88-btn primary" disabled={isSubmitting}>
                            Submit & Launch
                          </button>
                        )}
                      </div>
                    </form>
                  </div>

                  <div className="compinitf88-preview">
                    <h2>
                      Company Preview <BsQuestionCircle />
                    </h2>
                    <div className="compinitf88-preview-main">
                      <figure>
                        <Image
                          alt="company logo"
                          width={130}
                          src={preview.logo || "error"}
                          fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=="
                          style={{objectFit: "contain"}}
                        />
                      </figure>
                      <h3>{preview.name}</h3>
                      <p>{preview.tagline}</p>
                      <p className="compinitf88-tagline">{preview.industry}</p>
                      <button type="button">
                        <MdAdd size={25} /> Follow
                      </button>
                    </div>
                  </div>
                </main>
              );
            }}
          </Formik>
        </div>
      </section>

      {showLoader && (
        <div className="compinitf88-loader">
          <div className="compinitf88-loader-spinner" />
          <p>Setting up your company workspace...</p>
        </div>
      )}
    </div>
  );
};
